// Copyright (c) 2016 Deere & Company

import {getColumnSeparator} from '../../../shared/services/get-column-separator';
import {getDateFormat} from '../../../shared/services/get-date-format';
import {getStore} from '../../../store-factory';
import moment from 'moment';
import {getFormattedCellValues as processCellCallback} from './reports';

export const exportToCSV = (fileName, gridApi) => {

    const columnSeparator = getColumnSeparator(getStore().getState().user.details.settings.general.csvSeparator.key);

    const timeStamp = moment.utc().format(getDateFormat(getStore().getState().user.details.settings.general.dateFormat.key));

    const exportToCsvParams = {
        columnSeparator,
        fileName: `${fileName}-${timeStamp}.csv`,
        processCellCallback
    };

    gridApi.exportDataAsCsv(exportToCsvParams);

};



// WEBPACK FOOTER //
// ./src/reports/shared/services/export-to-csv.js